/**
 * GlobalView — App Entry
 *
 * Initialises auth listener and renders the router.
 */

import { useEffect } from 'react';
import AppRouter from './router/Router';
import ToastContainer from './components/ui/Toast';
import { useAuthStore } from './stores/authStore';

export default function App() {
  const initialize = useAuthStore((s) => s.initialize);

  useEffect(() => {
    const unsubscribe = initialize();
    return unsubscribe;
  }, [initialize]);

  return (
    <>
      <AppRouter />
      <ToastContainer />
    </>
  );
}
